import React from "react";

const WizardProgress = ({ steps, index }) => {
    const getCircles = () => {
        return steps.map((step, i) => {
            return (
                <span key={i}>
                    <div className={`circle ${i < index ? "done" : i === index ? "current" : "todo"}`}></div>
                    <p className="checkpointTitle" style={i > index ? { color: '#677D95' } : undefined}>{step.title}</p>
                </span>
            );
        });
    }

    return (
        <div>
            <div className="wizard progress">
                <div className="wizard progress-bar" role="progressbar"
                     style={{width: `${100 * index / (steps.length - 1)}%`}}
                     aria-valuemax="100" aria-valuemin="0"/>
            </div>
            <div className="checkpoints">
                {getCircles()}
            </div>
        </div>
    )
}

export default WizardProgress;